import { patchCachedRequestsHeaders } from '../api/offline';
import { triggerAction } from '../constants';
import { getProjects } from './createVsla';
import { fetchVslas } from './getVslas';
import { getLearningData } from './learning';
import { getCountries } from './location';

export const precacheData = () => {
  return async (dispatch, getState) => {
    const user = getState().user;
    if (user?.token) {
      try {
        await Promise.all([
          patchCachedRequestsHeaders(),
          dispatch(triggerAction('UPDATE_LOADER_STATE', true)),
          dispatch(fetchVslas()),
          dispatch(getLearningData()),
          dispatch(getProjects()),
          dispatch(getCountries())
        ]);
        console.log('Pre-caching complete.');
      } catch (error) {
        console.error('Pre-caching failed:', error);
      }
      finally {
        dispatch(triggerAction('UPDATE_LOADER_STATE', false));
      }
    }
  };
};

export const precacheMedia = async (mediaUrls) => {
  try {
    const cache = await caches.open("media-cache");
    const promises = mediaUrls.map(async (url) => {
      // fetch will follow redirects by default and return the final response.
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch ${url}: ${response.statusText}`);
      }
      // Use the original URL as the cache key, which matches the URL used by the component.
      await cache.put(url, response);
    });
    await Promise.all(promises);
    console.log("Media pre-caching complete.");
  } catch (error) {
    console.error("Media pre-caching failed:", error);
  }
};
